export default "/assets/images/overreactor-small.d3e55721cf1d81f1.webp";